import React from "react";
import { Button, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ContentLayout,
  HeaderBreadcrumbs,
  usePermission,
  useTabs,
} from "../../../shared";
import { AccountUploads, OverwriteRequests } from "../components";

export const ListDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isStoreAdmin = location.pathname.includes("/store-admin");
  const createPermission = usePermission("pl-bs-account-create");

  const { setCurentTab: setCurrentTab } = useTabs();

  const tabs = React.useMemo(
    () => [
      {
        label: "Account Uploads",
        value: "1",
        panel: <AccountUploads />,
      },
      {
        label: (
          <Typography gap={1} display="flex" flexDirection="row">
            Overwrite Requests
            {/* {state.overwriteRequest.list.length > 0 && ( */}
            {/* <Stack
              alignItems="center"
              justifyContent="center"
              sx={{
                borderRadius: "30px",
                backgroundColor: "primary.main",
                color: "#ffff",
                width: "24px",
                height: "24px",
              }}
            >
              <Typography
                fontSize="12px"
                fontWeight={500}
                lineHeight="18px"
                textAlign="center"
              >
                {state.overwriteRequest.list.length}
              </Typography>
            </Stack> */}
            {/* )} */}
          </Typography>
        ),
        value: "2",
        panel: <OverwriteRequests />,
      },
    ],
    []
  );

  // Set the current tab based on the URL search parameter
  React.useLayoutEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (location.search && searchParams.get("tab") === "overwrite-requests") {
      setCurrentTab("listDetails", "2");

      // Remove the search parameter from the URL without reloading the page
      window.history.replaceState(null, "", location.pathname);
    }
  }, []);

  return (
    <ContentLayout
      title={isStoreAdmin ? "Account Uploads" : "PL & BS Upload"}
      breadcrumbs={
        <HeaderBreadcrumbs
          links={[
            { name: "Dashboard", href: "/" },
            { name: isStoreAdmin ? "Account Uploads" : "PL & BS List" },
          ]}
        />
      }
      rightContent={
        createPermission && (
          <Button
            type="button"
            size="medium"
            variant="contained"
            onClick={() => navigate("create")}
          >
            Upload
          </Button>
        )
      }
      tabProps={
        isStoreAdmin
          ? undefined
          : {
              label: "listDetails",
              list: tabs,
            }
      }
    >
      {isStoreAdmin && <AccountUploads />}
    </ContentLayout>
  );
};
